import ScrollReveal from 'scrollreveal';

import {
    Controller
} from "stimulus"

export default class extends Controller {

    /**
     * The scrollreveal defaults
     *
     * @returns {{delay: number, distance: string, origin: string} & {}}
     */
    get defaults() {
        return  Object.assign({
            origin: 'top',
            delay: this.data.has('delay') ? parseInt(this.data.get('delay')) : 0,
            distance: '100px',
            afterReveal: this.afterReveal.bind(this)
        }, {})
    }

    /**
     * The scrollreveal config
     * @returns {*}
     */
    get config() {
        let config = JSON.parse(this.data.get('config'))

        if (!config) {
            return this.defaults
        }

        return Object.assign(this.defaults, config)
    }

    /**
     * The controller has loaded.
     */
    initialize() {
        this.element.classList.add('hidden')
        this.listen()
        this.start()
    }

    /**
     * Listen for page changes
     */
    listen() {
        document.addEventListener('turbolinks:before-visit', this.stop)
    }

    /**
     * Start scroll reveal
     */
    start() {
        ScrollReveal().reveal(this.element, this.config);
    }

    /**
     * Stop scroll reveal. Stops all instances.
     */
    stop() {
        ScrollReveal().destroy();
    }

    /**
     * Stop listening for page changes.
     */
    stopListening() {
        document.removeEventListener('turbolinks:before-visit', this.stop)
    }

    /**
     * The controller has disconnected.
     */
    disconnect()
    {
        this.stopListening()
    }

    /**
     * Handle the afterreveal event.
     */
    afterReveal()
    {

    }

}
